import { authClient, API } from '../index'

export const getDepartmentsAdmin = () => {
  return authClient().get(`${API}/departments/admin`)
}

export const postDepartment = (data) => {
  return authClient().post(`${API}/departments`, data)
}

export const updateDepartment = (id, data) => {
  return authClient().put(`${API}/departments/${id}`, data)
}

export const deleteDepartment = (id) => {
  return authClient().delete(`${API}/departments/${id}`)
}
